import { Injectable } from '@angular/core';
import { Http, Headers } from '@angular/http';
import { MainService} from './main.service';

@Injectable()
export class ProfileService {

  constructor(public http: Http, public mainService: MainService) { }

  findAll() {
    let promise = new Promise((resolve, reject) => {
      this.http.get(this.mainService.server_url+"profile")
        .toPromise()
        .then(
          res => { // Success
            resolve(res.json());
          },
          msg => { // Error
            reject(msg);
          }
        );
    });
    return promise;
  }

  find(idProfile :number) {
    let promise = new Promise((resolve, reject) => {
      this.http.get(this.mainService.server_url+"profile/"+idProfile)
        .toPromise()
        .then(
          res => { // Success
            resolve(res.json());
          },
          msg => { // Error
            reject(msg);
          }
        );
    });
    return promise;
  }

  create(profile:any){
    let promise = new Promise((resolve, reject) => {
      this.http.post(this.mainService.server_url+"profile",profile)
        .toPromise()
        .then(
          res => { // Success
            resolve(res.json());
          },
          msg => { // Error
            reject(msg);
          }
        );
    });
    return promise;
  }

  edit(profile:any){
    let promise = new Promise((resolve, reject) => {
      this.http.put(this.mainService.server_url+"profile/"+profile.idProfile,profile)
        .toPromise()
        .then(
          res => { // Success
            resolve(res.json());
          },
          msg => { // Error
            reject(msg);
          }
        );
    });
    return promise;
  }

  remove(id:number){
    let promise = new Promise((resolve, reject) => {
      this.http.delete(this.mainService.server_url+"profile/"+id)
        .toPromise()
        .then(
          res => { // Success
            resolve(res.json());
          },
          msg => { // Error
            reject(msg);
          }
        );
    });
    return promise;
  }
}



// WEBPACK FOOTER //
// ./src/app/services/profile.service.ts